// The backend reports an unlimited quota (an org override of -1) as this plan amount.
export const UNLIMITED_QUOTA = 999999;

export const isUnlimitedQuota = (planAmount: number | undefined): boolean =>
  (planAmount ?? 0) >= UNLIMITED_QUOTA;
